{
  "pt": {
    "subscription": {
      "customers": {
        "announcement": {
          "description": "Receber uma notificação quando forem publicadas novas mensagens.",
          "label": "Publicações de notícias"
        },
        "question": {
          "description": "Receber uma notificação quando forem adicionadas novas perguntas à secção FAQ.",
          "label": "FAQ"
        }
      },
      "employees": {
        "announcement": {
          "description": "Receber uma notificação quando forem publicadas novas mensagens.",
          "label": "Publicações de notícias"
        },
        "decision": {
          "description": "Receber notificações relacionadas com as decisões.",
          "label": "Decisões"
        },
        "document": {
          "description": "Receber uma notificação quando forem carregados novos documentos.",
          "employee_create": {
            "description": "Receber uma notificação quando documentos forem carregados por outros colaboradores.",
            "label": "Documentos por colegas"
          },
          "label": "Documentos"
        },
        "export": {
          "description": "Receber uma notificação quando são geradas exportações.",
          "label": "Exportações"
        },
        "question": {
          "description": "Receber uma notificação quando forem adicionadas novas perguntas à secção FAQ.",
          "label": "FAQ"
        },
        "survey": {
          "description": "Receber notificações relacionadas com inquéritos.",
          "label": "Inquéritos"
        },
        "ticket": {
          "description": "Receber notificações relacionadas com as conversas.",
          "label": "Conversas"
        },
        "todo": {
          "description": "Receber uma notificação quando for atribuído como responsável por uma tarefa.",
          "label": "Tarefas Atribuições"
        }
      },
      "labels": {
        "email_preferences": "As minhas preferências de notificação por correio eletrónico",
        "general_preferences": "As minhas preferências de notificação",
        "receiveEmailNotificationsAbout": "Receber notificações por correio eletrónico"
      }
    }
  }
}
